var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"btn-edit",style:({
        'font-size': _vm.size+'px'
    }),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("mdi-pencil")])}
var staticRenderFns = []

export { render, staticRenderFns }